import Vue from 'vue'
import Vuex from 'vuex'
import {api} from './axios'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    projects: [],
    entries: [],
    loading: false,
    errors: [],
    month: 10,
    year: 2018,
    track: null
  },
  getters: {
    projects: state => state.projects,
    entries: state => state.entries,
    errors: state => state.errors
  },
  mutations: {
    SET_PROJECTS (state, projects) {
      state.projects = projects;
    },
    SET_ENTRIES (state, entries) {
      state.entries = entries;
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    ADD_ERROR(state, err) {
      state.errors.push(err);
    },
    SET_TRACK(state, track) {
      state.track = track;
    },
    CLEAR_NEW_ENTRY(state) {
      state.newEntry = null;
    },
    ADD_ENTRY(state, entry) {
      state.entries.push(entry);
    },
    UPDATE_ENTRY(state, payload) {
      for (let i = 0; i < state.entries.length; ++i) {
        if (state.entries[i]._id == payload.id) {
           Object.assign(state.entries[i], payload.entry);
           return;
        }
      }
    },

    ADD_PROJECT(state, project) {
      state.projects.push(project);
    },
    removeEntry(state, index) {
      state.entries.splice(index, 1);
    },
    setYear(state, year) {
      state.year = year;
    },
    setMonth(state, month) {
      state.month = month;
    },
    initialiseStore(state) {
      if (localStorage.getItem('hora_store')) {
        let new_state = JSON.parse(localStorage.getItem('hora_store'));
        this.replaceState(Object.assign(state, new_state));
      }
    }
  },
  actions: {
    addEntry({commit, state}, entry) {
      api.post('/entries', entry).then(_ => {
        commit('ADD_ENTRY', entry);
      })
    },
    addProject({ commit }, project) {
      api.post('/projects', project)
        .then(() => {
          commit('ADD_PROJECT', project);
        });
    },
    updateEntry({commit, state}, payload) {
      api.put('/entries/' + payload.id, payload.entry).then(_ => {
        commit('UPDATE_ENTRY', payload);
      })
    },
    clearNewEntry ({commit}) {
      commit('CLEAR_NEW_ENTRY');
    },
    loadProjects ({commit}) {
      commit('SET_LOADING', true);
      api
        .get('/projects')
        .then(r => r.data)
        .then(projects => {
          commit('SET_PROJECTS', projects);
          commit('SET_LOADING', false);
        })
        .catch(err => {
          commit('ADD_ERROR', err)
        })
    },
    loadEntries ({commit}) {
      commit('SET_LOADING', true);
      api
        .get('/entries')
        .then(r => r.data)
        .then(entries => {
          commit('SET_ENTRIES', entries);
          commit('SET_LOADING', false);
        })
        .catch(err => {
          commit('ADD_ERROR', err)
        });
    }
  }
});

store.subscribe((mutation, state) => {
  localStorage.setItem('hora_store', JSON.stringify(state));
});

export default store;

